import React, { useEffect, useState } from 'react';
type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};
function getTimeLeft(target: number): TimeLeft {
  const difference = Math.max(0, target - Date.now());
  return {
    hours: Math.floor(difference / 3600000),
    minutes: Math.floor(difference / 60000 % 60),
    seconds: Math.floor(difference / 1000 % 60)
  };
}
export function UrgencyCountdown() {
  const [target] = useState(() => Date.now() + 5 * 60 * 60 * 1000);
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(target));
  useEffect(() => {
    const interval = window.setInterval(() => setTimeLeft(getTimeLeft(target)), 1000);
    return () => window.clearInterval(interval);
  }, [target]);
  return <div className="rounded-2xl bg-brand-mint px-4 py-4" data-id="element-211" data-mp="hshctgw78uqf"><p className="text-xs font-extrabold uppercase tracking-wide text-brand-greenDark" data-id="element-212" data-mp="hqxs9e3ifxiu">La oferta de lanzamiento termina en</p><div role="timer" aria-live="polite" aria-label={`Quedan ${timeLeft.hours} horas, ${timeLeft.minutes} minutos y ${timeLeft.seconds} segundos`} className="mt-2 flex justify-center gap-2" data-id="element-213" data-mp="1xau72biiqsm3">{[['hs', timeLeft.hours], ['min', timeLeft.minutes], ['seg', timeLeft.seconds]].map(([label, value]) => <div key={label as string} className="min-w-[56px] rounded-xl bg-white px-2 py-2" data-id="element-214" data-mp="3l3egnhbzua3e"><p className="font-display text-2xl font-black tabular-nums text-brand-greenDark" data-id="element-215" data-mp="3p3escu7pk76r">{String(value).padStart(2, '0')}</p><p className="text-[9px] font-extrabold uppercase text-brand-gray" data-id="element-216" data-mp="3tzvs6lo9s9zo">{label}</p></div>)}</div></div>;
}